/** This file is auto generated by convertSvgToJsx.ts */

import React from 'react'
const globe_medium = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M.975 9.75C.827 10.477.75 11.23.75 12A11.23 11.23 0 0 0 5 20.808M.975 9.75C2.017 4.615 6.557.75 12 .75a11.23 11.23 0 0 1 9 4.5M.976 9.75H6.33c.68 0 1.29.476 1.455 1.136l.75 3c.233.93-.496 1.864-1.455 1.864H6l-1 5.058m0 0a11.203 11.203 0 0 0 7 2.442c4.316 0 8.064-2.43 9.95-5.997M21 5.25A11.2 11.2 0 0 1 23.25 12a11.2 11.2 0 0 1-1.3 5.253M21 5.25h-4.079c-.68 0-1.29.476-1.455 1.136l-.75 3c-.233.93.496 1.864 1.455 1.864h1.579l.791 4.75c.12.714.756 1.253 1.48 1.253h1.93"
    />
  </svg>
)
export default globe_medium
